const substrDrugs = ["morfina"];

export default substrDrugs;
